import { AdminPageCabecalhoComponent } from '../../shared/admin-page-cabecalho/admin-page-cabecalho.component';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { Permissao, PermissoesApiService } from '@cei-ufg/ngx-cei-seguranca';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CeiButtonComponent, CeiInputTextComponent, CeiPanelComponent, CeiSnackBarService } from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { notifyAdminFormError, notifyAdminFormSuccess, stopIfAdminFormInvalid } from '../../shared/admin-form.utils';

@Component({
  selector: 'cei-admin-permission-form',
  standalone: true,
  imports: [AdminPageCabecalhoComponent, CommonModule, FormsModule, RouterModule, CeiInputTextComponent, CeiButtonComponent, CeiPanelComponent],
  templateUrl: './permission-form.component.html',
  // styleUrls removido: arquivo SCSS inexistente
})
export class AdminPermissionFormComponent {
  form: Partial<Permissao> = { name: '', codename: '' };
  permissoesApi = inject(PermissoesApiService);
  cdr = inject(ChangeDetectorRef);
  private readonly snackBar = inject(CeiSnackBarService);

  onSubmit(form: NgForm) {
    if (stopIfAdminFormInvalid(form)) {
      this.cdr.markForCheck();
      return;
    }

    this.permissoesApi.permissaoCreate({ permissao: this.form as Permissao }).subscribe({
      next: () => {
        notifyAdminFormSuccess(this.snackBar, 'Permissão criada com sucesso!');
        this.form = { name: '', codename: '' };
        this.cdr.markForCheck();
      },
      error: (err) => {
        notifyAdminFormError(this.snackBar, 'Erro ao criar permissão.', err);
        this.cdr.markForCheck();
      }
    });
  }
}
